jQuery(function() {
    jQuery('a[disabled]').on('click', function(e) {
        return false;
    });

});
